module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"List users","eu":"Email of the user"},"fr":{"title":"Liste des utilisateurs","eu":"E-mail de l\u0027utilisateur"}}')
  delete Component.options._Ctor
}
